import React, { useEffect, useState } from 'react';
import Universalpageheader from '../Headers/universalpageheader';
import { useLocation } from 'react-router-dom';
import fetch from '../Utils/fetch';
import Productcard from '../Products/productcard';
import { CircularProgress } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setAlert } from '../../store/alert';
import Searchbar from '../Components/searchbar';


function Searchitempage() {
    const dispatch = useDispatch();
    const subProducts = useSelector((state) => state.subProducts.data);
    const location = useLocation()
    const hint = location.state?.hint

    const [query, setquery] = useState(hint);
    const [loading, setloading] = useState(true);
    const [showsearchbar, setshowsearchbar] = useState(false);

    const [displayeditems, setdisplayeditems] = useState([]);

    useEffect(() => {
        searchQuery()
    }, [query]);

    function searchQuery() {
        setdisplayeditems([])
        setloading(true);
        dispatch(setAlert('Starting search...'));
        fetch
            .get(`searchItems`, { query: query === '*' ? '' : query, item_group: 'ALL' })
            .then(res => {
                setloading(false);
                setdisplayeditems(res.list)
            })
            .catch(err => {
                setloading(false);
                dispatch(setAlert({ type: 'error', message: 'Error searching! ' + err.message }));
            });
    }


    return (
        <div className="homebody">
            {showsearchbar && <Searchbar onsearchpage={(value) => {
                setquery(value)
                setshowsearchbar(false)
            }} searchpage={true} dismissmodals={() => setshowsearchbar(false)} products={subProducts?.flatMap((obj) => obj.items)} />}
            <Universalpageheader onshowsearch={() => setshowsearchbar(true)} pagename={query} withbackicon={true} />
            {loading && <div className='mainloadingdiv'><CircularProgress /></div>}
            <div >
                <div className='wrapfourcards'>
                    {displayeditems?.slice(0, 30).map((val, key) => {
                        return (
                            <Productcard product={val} key={key} showoffer={true} />
                        )
                    })}
                </div>
            </div>
        </div>
    );
}


export default Searchitempage;
